// @ts-nocheck
import React, { useEffect, useState } from 'react'
import withAdminAuthComponent from '../HOC/withAdminAuthComponent'
// import { listUsers } from '../../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import { createOrganization, createUserOrganizations } from '../../graphql/mutations';
import { createUserOrganizationsCustom } from '../../graphql/customMutations'
import ProfilePictureRounded from '../ProfilePictureRounded';
import { uploadData } from '@aws-amplify/storage';
import { listUsers } from '../../graphql/queries';

const defaultFormState = {
  name:"",
  description:"",
  owner:""
}

const client = generateClient();

const OrganizationUpdateMemberShip = ({organizationId}) => {
    const [file, setFile] = useState(null);
    const [userList, setUserList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [formComplete, setFormComplete] = useState(false);
    
    // Fetch all users
    const getAllUsers = async () => {
        const client = generateClient();
        const { data } = await client.graphql({
            query: listUsers,
        });
        setUserList(data.listUsers.items);
    };
    
    useEffect(() => {
        getAllUsers();
    }, []);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            for (const userId of selectedItems) {
                console.log(`userId: ${userId}, organizationId: ${organizationId}`);
                const { data } = await client.graphql({
                    query: createUserOrganizationsCustom,
                    variables: { 
                        input: {
                            organizationId: organizationId,
                            userID: userId
                        } 
                    },
                });
                console.log("Create user Organization", data);
            }
            setSelectedItems([]);
            setFormComplete(true);
            
            // Auto-hide success message after 3 seconds
            setTimeout(() => {
                setFormComplete(false);
            }, 3000);
            
        } catch (e) {
            console.log("error", e);
        }
    };
    
    const isSelected = (id) => selectedItems.includes(id);
    
    const handleSelect = (id) => {
        setSelectedItems((prevSelected) => {
            if (prevSelected.includes(id)) {
                // If item is already selected, remove it
                return prevSelected.filter((item) => item !== id);
            } else {
                // If item is not selected, add it
                return [...prevSelected, id];
            }
        });
    };
    
    return (
        <div>
            <h2 className="eai-panel-title">Manage Organization Members</h2>
            <p className="eai-description-sm mt-0.5">
                Select users to add to this organization.
            </p>

            <form onSubmit={handleSubmit} className="mt-4">
                <div className="eai-card max-h-[300px] divide-y divide-eai-border overflow-y-auto">
                    {userList.map((user) => (
                        <label
                            key={user.id}
                            htmlFor={`user-${user.id}`}
                            className="flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-eai-surface-hover"
                        >
                            <input
                                type="checkbox"
                                id={`user-${user.id}`}
                                checked={isSelected(user.id)}
                                onChange={() => handleSelect(user.id)}
                                className="h-4 w-4 shrink-0 accent-eai-cta-primary"
                            />
                            <ProfilePictureRounded
                                className="shrink-0 border border-eai-border"
                                diameter={32}
                                pictureURL={user.profilePictureUrl}
                            />
                            <div className="min-w-0">
                                <p className="eai-card-title truncate">{user.name}</p>
                                <p className="eai-description-sm truncate">{user.email}</p>
                            </div>
                        </label>
                    ))}
                </div>

                <div className="mt-4 flex flex-wrap items-center gap-3">
                    <button type="submit" className="eai-btn-cta" disabled={selectedItems.length === 0}>
                        Add Selected Members
                    </button>

                    {formComplete && (
                        <span className="font-inter text-eai-body-sm text-eai-success-text">
                            Members added successfully.
                        </span>
                    )}
                </div>
            </form>
        </div>
    );
};

export default withAdminAuthComponent(OrganizationUpdateMemberShip)